import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Desktop from "./Views/Test/Desktop";
import Landing from "./Views/Landing";
import Magazine from "./Views/Magazine/Magazine";
import LakshmiMagazine from "./Views/Magazine/LakshmiMagazine";
import LakshmiHome from "./Views/LakshmiHome/LakshmiHome";
import AboutPage from "./Views/About";
import ContactPage from "./Views/Contact";
import Navbar from "./Components/Navbar/Navbar";

function AppRoutes() {
  return (
    <>
    
      <Navbar />
          <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/celentaine" element={<Desktop />} />
      <Route path="/Celandine-The-Sunlit-Bloom" element={<Magazine />} />
      <Route path="/lakshmi-praba" element={<LakshmiHome />} />
      <Route path="/lakshmi-praba-magazine" element={<LakshmiMagazine />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/contact" element={<ContactPage />} />
    </Routes>
    </>

  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
